import React from "react";
import OrderReceiptsDashboard from "./OrderRecipts";
import Pdf from "../../assets/pdf/recipe.pdf";

class PDFRecipe extends React.Component {
  render() {
    return (
      <div>
        <OrderReceiptsDashboard file={Pdf} />
      </div>
    );
  }
}

export default PDFRecipe;
